/* The footer works immediately, including before its Shopify page is created. */
(() => {
  'use strict';
  if (window.LRSDeliveryGuide) return;
  window.LRSDeliveryGuide = true;

  let opener = null;
  let lockedDialog = null;
  let previousHtmlOverflow = '';
  let previousBodyOverflow = '';

  const unlock = (dialog) => {
    if (lockedDialog !== dialog) return;
    document.documentElement.style.overflow = previousHtmlOverflow;
    document.body.style.overflow = previousBodyOverflow;
    lockedDialog = null;
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
    opener = null;
  };

  const close = (dialog) => {
    if (!dialog) return;
    if (typeof dialog.close === 'function') dialog.close();
    else {
      dialog.removeAttribute('open');
      unlock(dialog);
    }
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-delivery-guide-open]');
    if (trigger) {
      const dialog = document.getElementById(trigger.dataset.deliveryGuideOpen || 'lrs-delivery-guide-dialog');
      if (!dialog) return;
      event.preventDefault();
      if (dialog.open) return;
      opener = trigger;
      previousHtmlOverflow = document.documentElement.style.overflow;
      previousBodyOverflow = document.body.style.overflow;
      lockedDialog = dialog;
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else {
        dialog.setAttribute('open', '');
        dialog.setAttribute('role', 'dialog');
        dialog.setAttribute('aria-modal', 'true');
      }
      dialog.scrollTop = 0;
      const firstControl = dialog.querySelector('[data-delivery-guide-close]');
      if (firstControl) firstControl.focus({ preventScroll: true });
      return;
    }
    const closer = event.target.closest('[data-delivery-guide-close]');
    if (closer) {
      const dialog = closer.closest('dialog');
      if (dialog && dialog.id === 'lrs-delivery-guide-dialog') {
        event.preventDefault();
        close(dialog);
      }
    }
  });

  const connect = () => {
    const dialog = document.getElementById('lrs-delivery-guide-dialog');
    if (!dialog || dialog.dataset.deliveryGuideConnected === 'true') return;
    dialog.dataset.deliveryGuideConnected = 'true';
    dialog.addEventListener('close', () => unlock(dialog));
    dialog.addEventListener('cancel', () => {
      // Native Escape closes the dialog and dispatches its close event.
      if (typeof dialog.close !== 'function') close(dialog);
    });
    dialog.addEventListener('keydown', (event) => {
      if (typeof dialog.showModal === 'function') return;
      if (event.key === 'Escape') {
        event.preventDefault();
        close(dialog);
        return;
      }
      if (event.key !== 'Tab') return;
      const controls = Array.from(dialog.querySelectorAll('a[href], button:not([disabled]), [tabindex="0"]')).filter((item) => item.getClientRects().length);
      const first = controls[0];
      const last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', connect, { once: true });
  else connect();
  document.addEventListener('shopify:section:load', connect);
})();
